<div class="main">
    <div> 
        <img src="assets/Nodatanoshow-icon.svg" alt=""> 
        <div style="margin-top: 15px;"> There is no data in this time range</div>
    </div>
</div>